import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { getGlobalStyleSheets } from '../../global-styles';
import { AtlSingleTabPanelProps } from './panels.props';
import { classMap } from 'lit/directives/class-map.js';
import { IClassMap } from '../helpers';
import { ifDefined } from 'lit/directives/if-defined.js';
import * as TagNames from './panels.tagnames';

@customElement(TagNames.SingleTab)
export class AtlSingleTabPanel
   extends LitElement
   implements AtlSingleTabPanelProps
{
   declare panelId: string;
   declare panelClassName: string;
   declare headerClassName?: string;
   declare title: string;

   static properties = {
      panelId: { type: String },
      panelClassName: { type: String },
      headerClassName: { type: String },
      title: { type: String },
   };

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   render() {
      const cardClass: IClassMap = { card: true, 'singletab-panel': true };
      if (this.panelClassName) {
         cardClass[this.panelClassName] = true;
      }

      const headerClassName: IClassMap = {
         'card-header': true,
         'd-inline-flex': true,
         'justify-content-between': true,
         'align-items-center': true,
         'w-100': true,
      };

      if (this.headerClassName) {
         headerClassName[this.headerClassName] = true;
      }

      return html`
         <div
            id=${ifDefined(this.panelId)}
            class=${classMap(cardClass)}
            part="panel"
         >
            <div class="${classMap(headerClassName)}">
               ${this.title}
               <slot name="titleSlot"></slot>
            </div>
            <div class="card-body mt-0">
               <slot></slot>
            </div>
         </div>
      `;
   }
}
